module.exports = "/_next/static/videos/skiing-2-2295e1987e2f9daaed82c9ae54ee6d24.webm";